/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { FindOptions } from './common';
import { entityService } from './services';

const pathname = '/material-categories';

export const MaterialCategoryApi = {
  filter: async (options: FindOptions) => {
    let url = pathname;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findMasterData: async () => {
    const url = `${pathname}/master-data`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);

      return response;
    } catch (error) {
      throw error;
    }
  },
};
